import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'contents', // use 'contents' to stop "root" wrapper div from influencing the layout
    },
    tooltip: {},
    text: {
      ...theme.typography.regular14,

      '& + &': {
        marginTop: theme.spacing(1),
      },
    },
  }),
  { name: 'TranslatedTooltipWrapper' }
);
